import { AutocompleteWithLabel } from '@adotel/components'
import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { Button } from '@material-ui/core'

import { DateObject } from '../../helpers/date'
import { getTranslate } from '../../localization'
import {
  HealthStatusType,
  InventoryType,
  MonitoringUpdateAccommodationLayerResponse
} from '../../types/monitoringUpdate'
import useStyles from './Styles/MonitoringUpdateFilters.style'

interface MonitoringUpdateFiltersProps {
  inventoryTypeAutocomplete: any
  setInventoryTypeAutocomplete: React.Dispatch<React.SetStateAction<any>>
  statusAutocomplete: any
  setStatusAutocomplete: React.Dispatch<any>
  setShowChannels: React.Dispatch<boolean>
  setShowCrsAndPms: React.Dispatch<React.SetStateAction<boolean>>
  selectedDateInDatePicker: DateObject
  getMonitoringAccommodationsData: LazyQueryExecFunction<
    {
      getUpdateMonitoringAccommodationLayer: MonitoringUpdateAccommodationLayerResponse
    },
    OperationVariables
  >
  loadingForAccomodationMonitoringUpdate: boolean
}

export default function MonitoringUpdateFilters({
  inventoryTypeAutocomplete,
  setInventoryTypeAutocomplete,
  statusAutocomplete,
  setStatusAutocomplete,
  setShowChannels,
  setShowCrsAndPms,
  getMonitoringAccommodationsData,
  selectedDateInDatePicker,
  loadingForAccomodationMonitoringUpdate
}: MonitoringUpdateFiltersProps) {
  const classes = useStyles()

  const inventoryTypeMenuItem: {
    value: InventoryType
    label: string
  }[] = [
    { value: 'CRS', label: 'CRS' },
    { value: 'PMS', label: 'PMS' },
    { value: 'Channel', label: 'Channel' }
  ]
  const statusMenuItem: {
    value: HealthStatusType
    label: string
  }[] = [
    { value: 'Normal', label: 'Normal' },
    { value: 'Warning', label: 'Warning' },
    { value: 'Critical', label: 'Critical' }
    // { value: 'Unexpected', label: 'Unexpected' }
  ]

  const onClickApply = () => {
    getMonitoringAccommodationsData({
      variables: {
        filters: {
          inventoryType:
            inventoryTypeAutocomplete && inventoryTypeAutocomplete.value,
          from: selectedDateInDatePicker.gregorianStartDate,
          to: selectedDateInDatePicker.gregorianEndDate,
          updateHealthStatus: statusAutocomplete
            ? statusAutocomplete.value
            : undefined
        }
      }
    })

    switch (inventoryTypeAutocomplete.value) {
      case 'CRS':
      case 'PMS':
        setShowChannels(false)
        setShowCrsAndPms(true)
        break
      case 'Channel':
        setShowChannels(true)
        setShowCrsAndPms(false)
        break
      default:
        setShowChannels(false)
        setShowCrsAndPms(false)
    }
  }

  const resetFilters = () => {
    setInventoryTypeAutocomplete(null)
    setStatusAutocomplete(null)
    setShowChannels(false)
    setShowCrsAndPms(false)
  }

  return (
    <div className={classes.root}>
      <div className={classes.eachRow}>
        <AutocompleteWithLabel
          label={getTranslate('Inventory Type')}
          inputSize="small"
          placeholder={getTranslate('Select Inventory Type')}
          value={inventoryTypeAutocomplete}
          onChange={(_, v: any) => {
            if (v) {
              setInventoryTypeAutocomplete({
                value: v.value,
                label: v.label
              })
            } else {
              setInventoryTypeAutocomplete(null)
              setStatusAutocomplete(null)
              setShowCrsAndPms(false)
              setShowChannels(false)
            }
          }}
          options={inventoryTypeMenuItem.map((item) => ({
            value: item.value,
            label: getTranslate(item.label)
          }))}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
        />
        <AutocompleteWithLabel
          label={getTranslate('Status')}
          inputSize="small"
          placeholder={getTranslate('Select Status')}
          value={statusAutocomplete}
          onChange={(_, v: any) => {
            if (v) {
              setStatusAutocomplete({
                value: v.value,
                label: v.label
              })
            } else {
              setStatusAutocomplete(null)
            }
          }}
          options={statusMenuItem.map((item) => ({
            value: item.value,
            label: getTranslate(item.label)
          }))}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
          disabled={!inventoryTypeAutocomplete}
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          variant="text"
          className={classes.resetButton}
          onClick={resetFilters}>
          {getTranslate('Reset')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickApply}
          disabled={
            !inventoryTypeAutocomplete || loadingForAccomodationMonitoringUpdate
          }>
          {getTranslate('Apply')}
        </Button>
      </div>
    </div>
  )
}
